import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddBankAccountTransactionMatchDefinitionRequest } from '../models/request/bankAccountTransactionMatchDefinition/AddBankAccountTransactionMatchDefinitionRequest';
import { GetBankAccountTransactionMatchDefinitionListPagingAndFilterRequest } from '../models/request/bankAccountTransactionMatchDefinition/GetBankAccountTransactionMatchDefinitionListPagingAndFilterRequest';

export class BankAccountTransactionMatchDefinitionService {
    static async getBankAccountTransactionMatchDefinitionList() {
        try {
            var inputObj = {

            };

            console.log('SERVICE CALL - getBankAccountTransactionMatchDefinitionList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/BankAccountTransactionMatchDefinition/getBankAccountTransactionMatchDefinitionList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportBankAccountTransactionMatchDefinitionList(inputObj: GetBankAccountTransactionMatchDefinitionListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportBankAccountTransactionMatchDefinitionList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/BankAccountTransactionMatchDefinition/exportBankAccountTransactionMatchDefinitionList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getBankAccountTransactionMatchDefinitionListPagingAndFilter(inputObj: GetBankAccountTransactionMatchDefinitionListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetBankAccountTransactionMatchDefinitionListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/BankAccountTransactionMatchDefinition/GetBankAccountTransactionMatchDefinitionListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addBankAccountTransactionMatchDefinition(inputObj: AddBankAccountTransactionMatchDefinitionRequest) {
        try {
            console.log('SERVICE CALL - AddBankAccountTransactionMatchDefinition', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/BankAccountTransactionMatchDefinition/AddBankAccountTransactionMatchDefinition', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteBankAccountTransactionMatchDefinition(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteBankAccountTransactionMatchDefinition', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/BankAccountTransactionMatchDefinition/deleteBankAccountTransactionMatchDefinition', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getBankAccountTransactionMatchDefinitionById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getBankAccountTransactionMatchDefinitionById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/BankAccountTransactionMatchDefinition/getBankAccountTransactionMatchDefinitionById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}